//let $ = $ || '';
//if(process.env.Test){
//    import $ from 'jquery';
//}
export const IMAGE_BASE_PATH = `${process.env.UrlScheme}://${process.env.siteUrl}`;
export const APP_VERSION = document.getElementById("hdnCurrVersion") ? document.getElementById("hdnCurrVersion") : '';
export const LOGGED_IN_USER_ID = (document.getElementById("hdnEncryptedUserId")) ? document.getElementById("hdnEncryptedUserId").value : null;
// export const VERIFICATION_TOKEN = $('input[name="__RequestVerificationToken"]')[0].value || "";
export const VERIFICATION_TOKEN = document.querySelector("input[name='__RequestVerificationToken']") ? document.querySelector("input[name='__RequestVerificationToken']").value : '';
export const WORKKARD_ID = (document.getElementById("hdncId")) ? document.getElementById("hdncId").value : null;
export const CHOOSE_AN_ACTIVITY_TEMPLATE = "Choose an activity template";
export const REOPEN_WORKKARD_TITLE = "Reopen Workkard";
export const ACTIVITY_LIST_PAGE_SIZE = 100;
export const DIARY_CANCELLED_TEXT = "Are you sure you wish to cancel this Diary?";
export const DIARY_CANCELLED_HEADER = "Diary Cancel Confirmation";
export const DETAIL_INFO = "Detail info";
export const IS_PARTIES_ENABLED = document.getElementById("hdnIsPartiesEnabled") ? document.getElementById("hdnIsPartiesEnabled").value.toLowerCase() : "true";
export const COMMENT_REQUIRED_ERROR = 'Comment is required';
export const CharConstants = {
    'Workkard': 'W',
    'Activity': 'A'
};

export const NotesFilterConstants = {
    All: {
        name: 'ALL', value: '0', checked: true,
        options: [
            { name: 'Reviewed', value: '1', checked: true },
            { name: 'Not Reviewed', value: '2', checked: true }
        ]
    }
};
export const DiariesConstants = {
    'day': 'Day',
    'month': 'Month',
    'list': 'List',
};

export const DiariesFilterConstants = {
    Priority: [
        { name: 'All Priorities', value: 'ALLP' },
        { name: 'High', value: '3' },
        { name: 'Normal', value: '2' },
        { name: 'Low', value: '1' }
    ],
    Status: [
        { name: 'All', value: 'ALL' },
        { name: 'Open', value: 'OPEN', selected: true },
        { name: 'Completed', value: 'COMPLETED' },
        { name: 'Cancelled', value: 'CANCELLED' },
    ],
    Sort: [
        { name: 'Due Date', value: 'SortByDueDate' },
        { name: 'Priority', value: 'SortByPriority' }
    ],
    Duration: [
        { name: 'Today', value: '1' },
        { name: 'Overdue', value: '2' },
        { name: 'Open', value: '3' },
        { name: 'Completed', value: '4' },
        { name: 'Cancelled', value: '8' },
        { name: 'This Week', value: '5' },
        { name: 'Next Week', value: '6' },
        { name: 'This Month', value: '7' }
    ]
};

export const FilesFilterConstants = {
    All: {
        name: 'ALL', value: '0', checked: true,
        options: [
            { name: 'Document', value: 'Document', checked: true },
            { name: 'Photo', value: 'Photo', checked: true },
            { name: 'Audio', value: 'Audio', checked: true },
            { name: 'Video', value: 'Video', checked: true },
            { name: 'Email', value: 'Email', checked: true },
            { name: 'Other', value: 'Other', checked: true },
        ]
    },
}

export const StringConstants = {
    'workkard': 'workkard',
    'EditWorkkard':'Edit workkard',
    'activity': 'activity',
    'Edit': 'Edit activity',
    'Clone': 'Clone activity',
    'Public': '_public',
    'Private': '_private',
    'CreateActivity': 'Create activity',
    'ReopenActivity': 'Reopen Activity',
    'CloneActivity': 'Clone Activity',
    'ChangeWorkkardSponsor': 'Change workkard owner',
    'InProgress': 'InProgress',
    'AddNote': 'Add note',
    'ReassignActivity': 'Reassign activity',
    'ChangeActivityOwner': 'Change activity owner',
    'HCPCI': 'Homeowners Choice Property & Casualty Insurance Company',
    'cancelled': 'CANCELLED',
    'open': 'OPEN',
    'Reopened': 'REOPENED',
    'CloseWorkkard': 'Close workkard',
    'ReopenWorkkard': 'Reopen workkard',
    'CloseActivity': 'Close activity',
    'Reopen': 'Reopen activity',
    'Complete': 'Complete activity',
    'Accept': 'Accept activity',
    'Reject': 'Reject activity',
    'PublicText': 'Public',
    'InternalText': 'Internal',
    'WorkkardOwnerText': 'Workkard owner',
    'ActivityOwnerText': 'Activity owner',
    'ActivityAssigneeText': 'Activity assignee',
    'ActivityOwnerAssigneeText': 'Activity owner & assignee',
    'RequestLetter': 'Request Letter',
    'common': 'common',
    'EditDiary': 'Edit',
    'CompleteDiary': 'Complete',
    'CompleteAndAddDiary': 'Complete and Add Diary',
    'CancelDiary': 'Cancel',
    'ReopenDiary': 'Re-Open',
    'ContactInsured':'Contact Insured',
    'ShareProposal': 'Share Proposal',
    'CarrierUPC':'United Property & Casualty Insurance Company',
    'RequestReview': 'Request Review',
};

export const ActivityActions = {
    '0': { Name: 'ReassignInterIntraOrganization', Type: '', Value: 'Reassign activity' },
    '1': { Name: 'AddPrivatePublicNoteWithInProgressOption', Type: '', Value: 'Add note' },
    '2': { Name: 'AddPrivatePublicNoteWithNoInProgressOption', Type: '', Value: 'Add note' },
    '3': { Name: 'AddPrivateNoteWithNoInProgressOption', Type: '', Value: 'Add note' },
    '4': { Name: 'AddPrivateNoteWithInProgressOption', Type: '', Value: 'Add note' },
    '5': { Name: 'AddPersonalNote', Type: '', Value: 'Add note' },
    '6': { Name: 'CloseMidTermPublic', Type: 'closeMidTerm', Value: 'Close activity' },
    '7': { Name: 'CloseMidTermPrivate', Type: 'closeMidTerm', Value: 'Close activity' },
    '8': { Name: 'ChangeActivityOwner', Type: '', Value: 'Change activity owner' },
    '9': { Name: 'InProgress', Type: '', Value: 'InProgress' },
    '10': { Name: 'ReOpenPrivate', Type: '', Value: 'Reopen activity' },
    '11': { Name: 'ReOpenPublic', Type: '', Value: 'Reopen activity' },
    '12': { Name: 'CompletePublic', Type: '', Value: 'Complete activity' },
    '13': { Name: 'CompletePrivate', Type: '', Value: 'Complete activity' },
    '14': { Name: 'AcceptPrivate', Type: '', Value: 'Accept activity' },
    '15': { Name: 'AcceptPublic', Type: '', Value: 'Accept activity' },
    '16': { Name: 'RejectPublic', Type: '', Value: 'Reject activity' },
    '17': { Name: 'RejectPrivate', Type: '', Value: 'Reject activity' },
    '18': { Name: 'ReassignIntraOrganization', Type: '', Value: 'Reassign activity' },
    '19': { Name: 'ClosePrivate', Type: 'close', Value: 'Close activity' },
    '20': { Name: 'ClosePublic', Type: 'close', Value: 'Close activity' },
    '21': { Name: 'EditActivity', Type: '', Value: 'Edit activity' },
    '22': { Name: 'CloneActivity', Type: '', Value: 'Clone activity' },
    '23': { Name: 'CreateActivity', Type: '', Value: 'Create activity' },
    '24': { Name: 'ChangeDueDate', Type: '', Value: 'Change due date' },
    '25': { Name: 'AddPublicNote', Type: '', Value: 'Add note' },
    '26': { Name: 'AddPrivateNote', Type: '', Value: 'Add note' },
    '27': { Name: 'CloseMidTerm', Type: 'closeMidTerm', Value: 'Close activity' },
    '28': { Name: 'ReOpen', Type: '', Value: 'Reopen activity' },
    '29': { Name: 'Complete', Type: '', Value: 'Complete activity' },
    '30': { Name: 'Accept', Type: '', Value: 'Accept activity' },
    '31': { Name: 'Reject', Type: '', Value: 'Reject activity' },
    '32': { Name: 'Close', Type: 'close', Value: 'Close activity' },
    '33': { Name: 'ReassignToTeamMember', Type: '', Value: 'Reassign activity' },
    '34': { Name: 'ReassignToB2B', Type: '', Value: 'Reassign activity' }
}

export const DiaryActions = {
    '0': { Name: 'Complete', Type: '', Value: 'Complete' },
    '1': { Name: 'Edit', Type: '', Value: 'Edit' },
    '2': { Name: 'Re-Open', Type: '', Value: 'Re-Open' },
    '3': { Name: 'Cancel', Type: '', Value: 'Cancel' },
};

export const WorkkardActions = {
    '0': { Name: 'CreateActivity', Type: '', Value: 'Create activity' },
    '1': 'CreateBidActivity',
    '2': { Name: 'ChangeWorkkardSponsor', Type: '', Value: 'Change workkard owner' },
    '3': 'LinkCompanionWorkkard',
    '4': { Name: 'AddPersonalNotes', Type: '', Value: 'Add note' },
    '5': { Name: 'AddPrivateNotes', Type: '', Value: 'Add note' },
    '6': { Name: 'AddPublicNotes', Type: '', Value: 'Add note' },
    '7': { Name: 'EditWorkkard', Type: '', Value: 'Edit workkard' },
    '8': { Name: 'CloseWorkkard', Type: '', Value: 'Close workkard' },
    '10': { Name: 'ContactInsured', Type: '', Value: 'Contact Insured' },
    '11': { Name: 'CanReopenWorkkard', Type: '', Value: 'Reopen workkard' },
    '12': { Name: 'ShareProposal', Type: '', Value: 'Share Proposal' },

}

export const ChangeOwnerType = {
    'single': 'single',
    'bulk': 'bulk',
}

export const RedirectURI = {
    'EditWorkkard': 'Edit workkard'
}

export const filterConstToShowInCombinedView = {
    itemToShow: 5,
    userItemToShow: 7
}
export const noteFilterConstants = {
    Activity: "detail",
    CombineView:"cv"
}

export const RightPanelConstant = {
    'CreateWorkkardButton': 'Create workkard',
    'WorkkardDetailText': 'Workkard details',
    'CombinedViewText': 'Combined view',
    'NormalView': 'Activities',
    'FinancialView': 'Financial',
    'LettersView': 'Letter',
    'PrintWorkkardDetailtext': 'Print workkard details',
    'CreateDiarytext': "Create diary",
    'AssociatedWorkkardsText': 'Associated workkards',
    'ViewAllText': 'view all',
    'ActivityAssigneeText': 'Activity assignee',
    'ChangeText': 'change',
    'FollowersText': 'Followers',
    'closeWorkKardDetails': 'Close',
    'CanReopenWorkkardPermissionDenied':'To Reopen this Workkard you need to either create an activity or reopen an activity. Please contact your supervisor for further support.',
    'ReviewsView': 'Review',
}

export const LeftPanelConstant = {
    'NoActivityFoundText': 'No Activity Found',
    'WorkkardText': 'Workkard',
    'ActivityText': 'Activity',
    'ActivitiesText': 'Activities',
    'Diaries': 'Diaries',
    "CanReopenWorkkardPermissionDenied": 'Creating an Activity will result in reopening of this Workkard. Please contact your supervisor for further support.',
};

export const MiddlePanelConstant = {
    'InProgressText': 'InProgress',
    'ReOpenText': 'ReOpen',
    'CompleteText': 'complete',
    'CloseActivityText': 'Close activity',
    'CloseWorkkardText': 'Close workkard',
    'ContactInsuredText': 'Contact Insured',
    'AcceptText': 'accept',
    'RejectText': 'reject',
    'CloseText': 'close',
    "CompleteActivityConfirmationText": 'Are you sure you want to complete this activity?',
    "ReopenActivityConfirmationText": 'Are you sure you want to reopen this activity?',
    "AcceptActivityConfirmationText": 'Are you sure you want to accept this activity?',
    "RejectActivityConfirmationText": 'Are you sure you want to reject this activity?',
    "CanReopenWorkkardPermissionDenied": 'Reopening this Activity will result in reopening of this Workkard. Please contact your supervisor for further support.',
    "CloneWorkkardPermissionDenied":'Cloning this Activity will result in reopening of this Workkard. Please contact your supervisor for further support.',
    'CompleteButtomText': 'Complete activity',
    'ReopenButtomText': 'Reopen activity',
    'AcceptButtomText': 'Accept activity',
    'RejectButtomText': 'Reject activity',
    'InProgressOption': [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    'DetailsText': 'details',
    'AddNoteButtonText': 'note',
    'CreateDiaryText': 'diary',
    'AddPartyText': 'Add party',
    'WorkkardType': 'workkard',
    'ActivityType': 'activity',
    "All": "All",
    'From': 'from',
    'To': 'To',
    'Note': {
        'ActivityTypeNote': 'Activity notes',
        'WorkkardTypeNote': 'Workkard notes',
        'Public': 'Public',
        'PublishPublicText': 'Publishing as Public will make this note visible to all participating organizations.',
        'Internal': 'Internal',
        'PublishInternal': 'Publishing as Internal will make this note visible only within your organization.',
        'DeleteNoteText': 'Are you sure you want to delete this note?',
        'ChangeResolutionText': 'Resolution changed from',
        'ReassignedFrom': 'Reassigned from',
        'To': 'to',
        'ReviewNotePlaceholder': 'Review Note',
        'ReviewedByText': 'Reviewed By',
        'PublishedByText': 'Published By ',
        'ReviewButtonText': 'Review',
        'PublishButtonText': 'Publish',
        'CloneButtonText': 'Clone',
        'EditButtonText': 'Edit',
        'DeleteButtonText': 'Delete',
    },
    'Log': {
        'ActivityTypeLog': 'Activity logs',
        'WorkkardTypeLog': 'Workkard logs',
        'ChangedText': 'changed',
        'AddedText': 'added',
        'CreatedText': 'created',
    },
    'Parties': {
        'ActivityTpyeParties': 'Activity parties',
        'WorkkardTypeParties': 'Workkard parties',
        'Organization': 'Organization',
        'ContactName': 'Contact name',
        'MailingAddress': 'Mailing address 1',
        'PartyType': 'Party type',
        'AssociatedWith': 'Associated with',
        'MailingCity': 'Mailing city'
    }
}

export const RenderEngineKey = {
    'CustomerName': 'Customer Name',
    'PropertyLocation': 'Property Location',
    'PolicyType': 'Policy Type',
    'LossType': 'Loss Type',
    'PolicyNumber': 'Policy Number',
    'AdjusterName': 'Adjuster Name',
    'CarrierContactName': 'Carrier Contact Name',
    'CarrierContactPhone': 'Carrier Contact Phone',
    'CarrierContactEmail': 'Carrier Contact Email',
    'CustomerPhone': 'Customer Phone',
    'CustomerEmail': 'Customer Email',
    'ClaimSource': 'Claim Source',
    'LitigationWorkkardNumber': 'Litigation Workkard Number',
    'CarrierClaimNumber':'Carrier Claim Number',
    'Track':'Track',
    'BuildingType': 'Building Type',
    'BuildingDescription':'Building Description',
    "LossDate": 'Loss Date',
    "ReportedDate": 'Reported Date',
    "ClaimType": 'Claim Type',
    "WorkkardNumber": 'Workkard Number',
    "WorkkardTitle": 'Workkard Title',
}

export const FileListing = {
    maxLengthToTruncateFileName: 71,
    startIndexOfSubstringTruncateFileName: 0,
    endIndexOfSubstringTruncateFileName: 58
}

export const openDiaryTitle = {
    maxLengthToTruncate: 36,
    startIndexOfSubstringTruncate: 0,
    endIndexOfSubstringTruncate: 35
}

export const MAX_UPLOAD_FILE_SIZE = 104857600; // in bytes
export const INVALID_FILES_TO_UPLOAD = (name) => (name.match(/^(exe|msi|pif|APPLICATION|GADGET|MSP|COM|SCR|HTA|CPL|MSC|JAR|BAT|CMD|VB|VBS|JS|JSE|WS|WSF|WSC|WSH|PS1|PS1XML|PS2|PS2XML|PSC1|PSC2|MSH|MSH1|MSH2|MSHXML|MSH1XML|MSH2XML|SCF|LNK|INF|REG|DOCM|DOTM|XLSM|XLTM|XLAM|PPTM|POTM|PPAM|PPSM|SLDM|VBE|DLL|JSON|JS_BAK|SH|SQL|IN|OUT|ICO)$/gi) ? true : false);


/**
 * Combined View entry types.
 *
 * These are the `webview.v1.CombinedViewEntryType` enum names, which the
 * gateway emits verbatim because it marshals the response with protojson. They
 * replace the old free-text `ttype` strings ("Workkard Action History"), where
 * a typo produced a silently unrendered row rather than an error.
 */
export const CombinedViewConstants = {
    'entryType': {
        'workkard': 'COMBINED_VIEW_ENTRY_TYPE_WORKKARD',
        'workkardNote': 'COMBINED_VIEW_ENTRY_TYPE_WORKKARD_NOTE',
        'workkardLog': 'COMBINED_VIEW_ENTRY_TYPE_WORKKARD_LOG',
        'workkardActionHistory': 'COMBINED_VIEW_ENTRY_TYPE_WORKKARD_ACTION_HISTORY',
        'workkardFile': 'COMBINED_VIEW_ENTRY_TYPE_WORKKARD_FILE',
        'activity': 'COMBINED_VIEW_ENTRY_TYPE_ACTIVITY',
        'activityNote': 'COMBINED_VIEW_ENTRY_TYPE_ACTIVITY_NOTE',
        'activityLog': 'COMBINED_VIEW_ENTRY_TYPE_ACTIVITY_LOG',
        'activityActionHistory': 'COMBINED_VIEW_ENTRY_TYPE_ACTIVITY_ACTION_HISTORY',
        'activityFile': 'COMBINED_VIEW_ENTRY_TYPE_ACTIVITY_FILE'
    }
}

export const CombinedViewSettingTypes = {
    WorkkardNotes: [CombinedViewConstants.entryType.workkardNote],
    WorkkardLogs: [CombinedViewConstants.entryType.workkardLog],
    WorkkardActions: [CombinedViewConstants.entryType.workkardActionHistory],
    WorkkardFiles: [CombinedViewConstants.entryType.workkardFile],
    ActivityNotes: [CombinedViewConstants.entryType.activityNote],
    ActivityLogs: [CombinedViewConstants.entryType.activityLog],
    ActivityActions: [CombinedViewConstants.entryType.activityActionHistory],
    ActivityFiles: [CombinedViewConstants.entryType.activityFile]
}

export const combinedViewTemplateCategoryConstants = {
    "activity": "activity",
    "activitynote": "activitynote",
    "workkard": "workkard",
    "workkardnote": "workkardnote"
};

export const getFilesNoteCategoryCombinedViewConstants = {
    "activity": "Activity",
    "activitynote": "ActivityNote",
    "workkard": "WorkkardFile",
    "workkardnote": "WorkkardNoteFile"
}

export const ResolutionNameConstants = {
    "inprogress": "In Progress",
    "closedmidterm": "Closed Mid-term",
    "closedrejected": "Rejected Closed",
    "reassignedclosed": "Reassigned Closed",
    "close": "Closed",
    "reopened": "Reopened",
    "assigned": "Assigned",
    "accepted": "Accepted",
    "rejected": "Rejected",
    "reassigned": "Reassigned",
    "rejectedclosed": "Rejected Closed",
    "completed": "Completed",
    "cancelled": "Cancelled"
}

export const ResolutionClassNameConstants = {
    "inprogress": "inprogress",
    "closedmidterm": "closemidterm",
    "closedrejected": "closedrejected",
    "reassignedclosed": "reassignedclosed",
    "close": "closed",
    "reopened": "reopened",
    "assigned": "assigned",
    "accepted": "accepted",
    "rejected": "rejected",
    "reassigned": "reassigned",
    "rejectedclosed": "rejectedclosed",
    "completed": "completed",
    "cancelled": "cancelled"
}

export const CLOSE_ACTIVITY_ERROR_VALIDATION_MESSAGE = {
    'warningMessage': 'This action cannot be performed since the item(s) you have selected may have already been changed by another user or you may not have the required permission(s).',
    'closeActivityErrorText': 'This action cannot be performed since the Activity Owner is blocked.',
}

export const ATTACH_WORKKARD_FILES = 'Attach workkard files';
export const ATTACH_WORKKARD_LETTER = 'Attach Letter';
export const CLOSE_WORKKARD_ERROR_VALIDATION_MESSAGE = {
    'FailureMessage': 'Something went wrong, please retry after sometime.',
    'ErrorMsg': 'This action is not valid on the selected records.',
    'UNAUTHORIZED_ACTION': 'It seems you do not have permissions to close activities within this Workkard, please contact your administrator.'
}

export const APP_ERROR_CODES = [404, 403, 503, 501, 500];
export const ErrorCode = {
    Success: 200,
    Fail: 400,
    InvalidFormData: 105,
    ValidationFailed: 405,
    NotFound: 404,
    UnAuthorize: 403,
    RedirectToLogout: 401,
    ActionDenied:402,
    ServerException: 503,
    DupicateField: 457,
    DataBaseException: 477,
    DivideByZero: 803,
    LuceneException: 647,
    FileSystemException: 797,
    NoContent: 204,
    SpockException: 407,
    NotAcceptable: 406,
    WriteOff: 210 //custom status code to stop write operations
}
// below array  will validate date to enter between claim loss date and current date
export const DATE_ARRAY_FIELDS = ["Date of Inspection", "Date of Representation", "Subsequent Inspection Date", "Pre-Mediation Report Date", "Date of Executed Release", "Date of Settlement", "Date of Final DA Invoice", "Motion Date Filed", "Notice/Misc. Date Filed", "MSJ Date Filed", "Date of Order Entered", "Pre-Trial Report Date", "Inspected On", "CRN Completion Date","Date Received in Claims","Date Of Service","PSD Demand Date","Offer Date","Agreed Settlement Date","Counter Offer Date","Date Notice Received","Mail Received Date","ICC Received Date"]

export const MAX_DATE_ARRAY_FIELDS=["Date of Representation", "Date Received in Claims","Date Of Service","Policy Effective Date","Loss Date","Reported Date","CRN Filed Date","Assumption Date"]

export const MIN_DATE_ARRAY_FIELDS=["Activity Due Date", "CRN Due Date"];

export const MIN_NOTE_TEMPLATE_DATE_ARRAY_FIELDS = ["Approved Date","Rejected Date","Request Date","Deposition Date","Inspection Appointment Attempted date","Inspection Completed date","EMS Inspection Appointment Attempted Date","EMS Inspection Completed Date"];

export const ACTIVITY_DATE_ARRAY_FIELDS=["Date of Representation","Date Received in Claims","Date Of Service","PSD Demand Date"];

export const SHOW_PROPERTY_TIMEZONE_DATE_FIELD=["Date of inspection","Inspected On","Inspection Date","Inspection Appointment Date","Subsequent Inspection Date","Appointment Date - Rescheduled","Appointment Date - Subsequent","EMS Inspection Date","Mail Received Date","ICC Received Date"]

export const DATE_FORMAT = document.getElementById("cuDynamicDatePattern") ? document.getElementById("cuDynamicDatePattern").value.toUpperCase() : "MM/DD/YYYY";

export const TIME_FORMAT = DATE_FORMAT + ', hh:mm A';

export const FILE_UPLOAD_URL = document.getElementById('nodeUrl') ? document.getElementById('nodeUrl').value : null;

export const ADD_NOTE_ERROR_MESSAGE = {
    "addDescription": 'Please add a description or attach a file to proceed.',
    "changeTemplate": "The entered note text will carry over to the newly selected note type. Some of the custom data field entry may be discarded and you will need to re-enter. Confirm to continue?",
    "saveDraftNote": "Are you sure you want to close your note or save it as a draft which you can use later ?",
    "discardNoteText": "The entered note text and custom data field entry will be discarded. Confirm to continue? "
}

export const NOTES_ERROR_CODES = {
    "203": "Required permission does not exist."
}

export const ExternalAppView = {
    "financial": "financial",
    "letter": "letter",
    "review": "review"
}

export const ReopenConstants = {
    createActivityNote: 'Opening an activity in a closed workkard results in reopening of the Workkard.',
    createActivitySubtext: 'Please select a reason to reopen the workkard',
    reopenWorkkardSubtext: 'Please select a reason to reopen the workkard',
    cloneActivityNote: 'Cloning an activity in a closed workkard results in reopening of the workkard.',
    reOpenActivityNote: 'Opening an activity in a closed workkard results in reopening of the workkard.',
    reOpenActivityNoteHideReason: 'Reopening an activity in a closed workkard results in reopening of the Workkard.',
    reOpenSubtext: 'Please select a reason and confirm to reopen the activity',
    editActivityNote: 'Editing an activity in a closed workkard results in reopening of the workkard.',
    editActivitySubtext: 'Please select a reason to reopen the workkard'
}

export const OrganisationNamesById = {
    "396" : "GristonTPA",
    "6" : "Homeowners Choice Property & Casualty Insurance Company",
    "507" : "Legal Staff Counsel",
    "465" : "Griston Litigation Group",
    "286" : "TypTap Insurance Company"
}

export const AssociatedWorkkard_ORGANIZATIONID_ARRAY = [396,507,670,465,508];
let isTrycc=document.getElementById('siteUrl').value.toLowerCase().includes("trycc");
let LegalTPAOrg=isTrycc?"670":"507";
let LitigationOrg=isTrycc?"508":"465";
export const AssociatedWorkkard_ORGANIZATIONION_FILTER_ARRAY = [{"396":[{Orgname:"GristonTPA",OrgId:"396"},{Orgname:"HCPCI",OrgId:"6"},{Orgname:"LitigationTPA",OrgId:LitigationOrg}]},
                        {[LegalTPAOrg]:[{Orgname:"GristonTPA",OrgId:"396"},{Orgname:"HCPCI",OrgId:"6"},
                        {Orgname:"LitigationTPA",OrgId:LitigationOrg},{Orgname:"TypTap",OrgId:"286"},{Orgname:"LegalTPA",OrgId:LegalTPAOrg}]},
                         {[LitigationOrg]:[{Orgname:"GristonTPA",OrgId:"396"},{Orgname:"LegalTPA",OrgId:LegalTPAOrg},{Orgname:"LitigationTPA",OrgId:LitigationOrg}]}] 
                        
export const PAGE_SIZE = 15;